"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[66],{

/***/ 3066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HTMLSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(608);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2606);



function HTMLSection(param) {
    let { data: { html  }  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_1__/* .ContainerSize.wide */ .B.wide,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "grid grid-cols-12 gap-1.5 md:gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "col-start-2 col-span-10 lg:col-start-4 lg:col-span-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center",
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            })
        })
    });
}


/***/ })

}]);